<template>
  <div class="main" ref="main">
    <template v-if="healthRiskData && healthRiskData.length">
      <h1>疾病风险预测结果</h1>
      <el-button
        style="float: right; margin-top: -30px"
        @click="$router.go(-1)"
        size="mini"
        >返回</el-button
      >
      <div class="diseaseRiskResult" ref="riskFactor">
        <img
          class="persionBody"
          v-if="gender == 0"
          src="@/assets/images/re_men.png"
        />
        <img class="persionBody" v-else src="@/assets/images/re_women.png" />
        <div v-for="(item, index) in riskResultData" :key="index">
          <img
            :class="getRiskLevelClassName(item.riskLevelName)"
            :style="{
              left: item.point.x + 'px',
              top: item.point.y + 'px',
              width: item.point.w + 'px',
              height: item.point.h + 'px',
            }"
            :src="item.src"
          />
          <poperView
            class="persionBodyPart-text"
            :style="{
              left: item.tPoint.x + 'px',
              top: item.tPoint.y + 'px',
              width: item.tPoint.w + 'px',
              height: item.tPoint.h + 'px',
              lineHeight: item.tPoint.h + 'px',
            }"
            @getData="getData"
            :arrow="index % 2 > 0 ? 'left' : 'right'"
            :index="index"
            :placement="'bottom'"
            :key="index"
            :data="bodyPartData"
            :riskLevelName="item.riskLevelName"
          >
            <span>{{ item.title }}</span>
            <!-- <div class="item" :style="{'borderColor': item.showPopover?`rgb(${$store.state.themeColor})`:'transparent'}">
                <span class="name">{{item.physiologySystemName}}</span>
                <span
                  class="statu"
                  :style="{color:$utils.judgeRiskLevel(item.riskLevel)}"
                >{{item.riskLevel}}</span>
              </div> -->
          </poperView>

          <!-- <span
          :key="index" 
          class="persionBodyPart-text"
          :style="{'left':item.tPoint.x + 'px','top':item.tPoint.y + 'px','width':item.tPoint.w + 'px','height':item.tPoint.h + 'px','lineHeight':item.tPoint.h + 'px'}"
          @click="clickValue(item,index)"
          >{{item.title}}</span> -->
        </div>
      </div>
      <h1 v-if="editableTabs.length">疾病风险评估值</h1>
      <div class="riskStatistical" v-if="editableTabs.length">
        <div class="riskStatisticalChart" ref="riskStatisticalChart"></div>
      </div>
      <h1 v-if="editableTabs.length">疾病风险评估详情</h1>
      <div class="diseaseRiskCard">
        <el-tabs
          v-model="editableTabsValue"
          type="card"
          @tab-click="handleClick"
        >
          <el-tab-pane
            :key="index"
            v-for="(item, index) in editableTabs"
            :label="item.title"
            :name="item.name"
          ></el-tab-pane>
        </el-tabs>
      </div>
      <div class="diseaseRiskDetail" v-if="diseaseInfo.rValue != 0">
        <p class="diseaseName">
          {{ diseaseInfo.diseaseName }}
          <span>{{ diseaseInfo.riskLevelName }}</span>
        </p>
        <div v-if="diseaseInfo.adviceCopy" class="diseaseDetail">
          {{ diseaseInfo.adviceCopy }}
        </div>
        <div
          v-if="diseaseInfo.suggestedInspectionItems"
          class="diseaseCheckRemind"
        >
          <p class="diseaseCheckRemind-title">建议筛查方法</p>
          <p class="diseaseCheckRemind-content">
            {{ diseaseInfo.suggestedInspectionItems }}
          </p>
        </div>
        <div class="diseaseRisk-compare">
          <!-- <p :style="{ width: diseaseRiskWidth + 'px' }"> -->
          <p style="width: 60%">
            发病风险为同龄一般人群的
            <span>{{ diseaseInfo.relativeRiskRate }}</span
            >倍
          </p>
          <compareProgress
            class="diseaseRiskProgress"
            :currentLevel="diseaseInfo.riskLevelName"
            :perfectLevel="diseaseInfo.aaaa"
            :levels="[
              '风险极低',
              '风险较低',
              '风险一般',
              '风险较高',
              '风险极高',
            ]"
            :levelColors="[
              '#72DB2B',
              '#72DB2B',
              '#C4EE54',
              '#FCDC71',
              '#FA9265',
              '#F7684B',
            ]"
            :texts="['风险等级', '理想风险', '当前风险']"
            ref="diseaseRiskProgress"
          ></compareProgress>
        </div>
        <div class="col">
          <!-- <el-row :gutter="20">
            <el-col :span="14">
              <div class="col-item">
                <p class="col-item-title">改善后风险趋势预测</p>
                <p class="col-item-title1">
                  从现在开始通过对可控的危险因素进行改善<br />未来患病风险趋势如下
                </p>
                <div
                  class="historyhealthTrendChart"
                  ref="historyhealthTrendChart"
                ></div>
              </div>
            </el-col>
            <el-col :span="14">
              <div class="col-item">
                <p class="col-item-title">
                  全平台{{ diseaseInfo.diseaseName }}风险人数占比
                </p>
                <div
                  class="riskStatisticalChart1"
                  ref="riskStatisticalChart1"
                ></div>
              </div>
            </el-col>
          </el-row> -->
          <div class="riskControl-name">相关风险因素</div>
          <div class="riskControl">
            <div class="riskControlType">
              <el-row>
                <el-col :span="12">
                  <div class="card-title">
                    <span class="card-title-icon"></span>
                    <span class="card-title-name">可控风险因素</span>
                  </div>
                  <div class="diseaseRisk-control">
                    <div
                      class="diseaseRisk-item"
                      v-for="(item, index) in diseaseInfo.controlRiskList"
                      :key="index"
                    >
                      <span class="diseaseRiskName">{{
                        item.riskFactorName
                      }}</span>
                      <span class="diseaseRiskValue"
                        >患病风险{{ item.rRValue }}倍</span
                      >
                    </div>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="card-title">
                    <span class="card-title-icon"></span>
                    <span class="card-title-name">不可控风险因素</span>
                  </div>
                  <div class="diseaseRisk-control">
                    <div
                      class="diseaseRisk-item1"
                      v-for="(item, index) in diseaseInfo.unControlRiskList"
                      :key="index"
                    >
                      <span class="diseaseRiskName">{{
                        item.riskFactorName
                      }}</span>
                      <span class="diseaseRiskValue">{{
                        item.rRValue
                          ? `患病风险${item.rRValue}倍`
                          : "患病风险暂无"
                      }}</span>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="riskControlStatu">
              <div class="dialogDiseaseRisk">
                <p class="dialogDiseaseRisk-prompt">风险因素影响程度</p>
                <div
                  class="dialogDiseaseRisk-effect"
                  v-for="(item, index) in diseaseInfo.riskDegree"
                  :key="index"
                >
                  <div class="dialogDiseaseRisk-effect-left">
                    <div
                      class="bigEffect"
                      :style="{
                        color: judgeRiskLevel(item.title),
                        backgroundColor: judgeRiskLevelBg(item.title),
                      }"
                    >
                      {{ item.title }}
                    </div>
                    <div
                      class="bigIcon"
                      :style="{ backgroundColor: judgeRiskLevelBg(item.title) }"
                    >
                      <div
                        class="bigIcon-center"
                        :style="{ backgroundColor: judgeRiskLevel(item.title) }"
                      ></div>
                    </div>
                  </div>
                  <div class="dialogDiseaseRisk-effect-right">
                    <div
                      class="dialogDiseaseRisk-effect-right-item"
                      v-for="(item1, index1) in item.list"
                      :key="index1"
                    >
                      <span class="diseaseRiskName">{{
                        item1.riskFactorName
                      }}</span>
                      <span class="diseaseRiskValue">{{
                        item1.rRValue
                          ? `患病风险${item1.rRValue}倍`
                          : "患病风险暂无"
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="literature-box" v-if="diseaseInfo.rValue != 0">
        <p class="literature-name">参考文献</p>
        <p
          class="literature-content"
          v-html="diseaseInfo.referenceDocuments"
        ></p>
      </div>
      <div
        v-if="diseaseInfo.rValue == 0"
        style="height: 300px; text-align: center; line-height: 300px"
      >
        暂无风险
      </div>
    </template>
    <template v-else>
      <div class="healthNonData">
        <img
          src="@/assets/images/hcalc2.png"
          class="healthNonDataImage"
          alt=""
        />
        <div class="healthNonDataText">暂无风险评估</div>
      </div>
    </template>
  </div>
</template>

<script>
import {
  getRValueDiseaseInfo,
  getHealthRValueDiseaseInfo,
  getHealthRiskEstimateList,
  getHealthUserAllDiseaseRisk,
} from "@/config/healthApi.js";
import compareProgress from "@/components/health/compareProgress";
import poperView from "@/components/health/poperView";
import { isEmpty, getYMDString, getYMDSimple } from "@/assets/js/until.js";

export default {
  components: {
    compareProgress,
    poperView,
  },
  name: "health-risk-assessment",
  data() {
    return {
      gender: 0, //0男 1 女
      lastSelectItem: null,
      lastSelectIndex: -1,
      leftShow: false,
      rightShow: false,
      // 女
      riskResultData1: [
        {
          title: "高血压",
          src: require("@/assets/images/bodyRisk/女-高血压0.png"),
          // highlightSrc: require("@/assets/images/bodyRisk/女-高血压h.png"),
          point: {
            x: 256,
            y: 54,
            w: 213,
            h: 28,
          },
          tPoint: {
            x: 261,
            y: 56,
            w: 82,
            h: 26,
          },
        },
        {
          title: "鼻咽癌",
          src: require("@/assets/images/bodyRisk/女-鼻咽癌0.png"),
          // highlightSrc: require("@/assets/images/bodyRisk/女-鼻咽癌h.png"),
          point: {
            x: 463,
            y: 46,
            w: 219,
            h: 33,
          },
          tPoint: {
            x: 596,
            y: 47,
            w: 82,
            h: 26,
          },
        },
        {
          title: "食管癌",
          src: require("@/assets/images/bodyRisk/女-食管癌0.png"),
          // highlightSrc: require("@/assets/images/bodyRisk/女-食管癌h.png"),
          point: {
            x: 256,
            y: 97,
            w: 214,
            h: 45,
          },
          tPoint: {
            x: 261,
            y: 98,
            w: 82,
            h: 26,
          },
        },
        {
          title: "肺癌",
          src: require("@/assets/images/bodyRisk/女-肺癌0.png"),
          // highlightSrc: require("@/assets/images/bodyRisk/女-肺癌h.png"),
          point: {
            x: 479,
            y: 139,
            w: 196,
            h: 27,
          },
          tPoint: {
            x: 603,
            y: 140,
            w: 68,
            h: 26,
          },
        },
        {
          title: "缺血性心血管病",
          src: require("@/assets/images/bodyRisk/女-缺血性心血管病0.png"),
          // highlightSrc: require("@/assets/images/bodyRisk/女-缺血性心血管病h.png"),
          point: {
            x: 228,
            y: 181,
            w: 243,
            h: 27,
          },
          tPoint: {
            x: 233,
            y: 182,
            w: 138,
            h: 26,
          },
        },
        {
          title: "乳腺癌",
          src: require("@/assets/images/bodyRisk/女-乳腺癌0.png"),
          // highlightSrc: require("@/assets/images/bodyRisk/女-乳腺癌h.png"),
          point: {
            x: 256,
            y: 210,
            w: 165,
            h: 40,
          },
          tPoint: {
            x: 261,
            y: 224,
            w: 82,
            h: 26,
          },
        },
        {
          title: "胃癌",
          src: require("@/assets/images/bodyRisk/女-胃癌0.png"),
          // highlightSrc: require("@/assets/images/bodyRisk/女-胃癌h.png"),
          point: {
            x: 484,
            y: 223,
            w: 191,
            h: 27,
          },
          tPoint: {
            x: 603,
            y: 224,
            w: 68,
            h: 26,
          },
        },
        {
          title: "肝癌",
          src: require("@/assets/images/bodyRisk/女-肝癌0.png"),
          // highlightSrc: require("@/assets/images/bodyRisk/女-肝癌h.png"),
          point: {
            x: 263,
            y: 240,
            w: 175,
            h: 52,
          },
          tPoint: {
            x: 268,
            y: 266,
            w: 68,
            h: 26,
          },
        },
        {
          title: "糖尿病",
          src: require("@/assets/images/bodyRisk/女-糖尿病0.png"),
          // highlightSrc: require("@/assets/images/bodyRisk/女-糖尿病h.png"),
          point: {
            x: 485,
            y: 265,
            w: 197,
            h: 27,
          },
          tPoint: {
            x: 596,
            y: 266,
            w: 82,
            h: 26,
          },
        },
        {
          title: "结直肠癌",
          src: require("@/assets/images/bodyRisk/女-结直肠癌0.png"),
          // highlightSrc: require("@/assets/images/bodyRisk/女-结直肠癌h.png"),
          point: {
            x: 468,
            y: 307,
            w: 221,
            h: 27,
          },
          tPoint: {
            x: 589,
            y: 308,
            w: 96,
            h: 26,
          },
        },
        {
          title: "膀胱癌",
          src: require("@/assets/images/bodyRisk/女-膀胱癌0.png"),
          // highlightSrc: require("@/assets/images/bodyRisk/女-膀胱癌h.png"),
          point: {
            x: 256,
            y: 324,
            w: 204,
            h: 52,
          },
          tPoint: {
            x: 261,
            y: 350,
            w: 82,
            h: 26,
          },
        },
        {
          title: "子宫颈癌",
          src: require("@/assets/images/bodyRisk/女-子宫颈癌0.png"),
          // highlightSrc: require("@/assets/images/bodyRisk/女-子宫颈癌h.png"),
          point: {
            x: 463,
            y: 333,
            w: 226,
            h: 43,
          },
          tPoint: {
            x: 589,
            y: 350,
            w: 96,
            h: 26,
          },
        },
      ], // 男
      riskResultData2: [
        {
          title: "高血压",
          src: require("@/assets/images/bodyRisk/男-高血压0.png"),
          // highlightSrc: require("@/assets/images/bodyRisk/男-高血压h.png"),
          point: {
            x: 257,
            y: 72,
            w: 213,
            h: 28,
          },
          tPoint: {
            x: 262,
            y: 74,
            w: 82,
            h: 26,
          },
        },
        {
          title: "鼻咽癌",
          src: require("@/assets/images/bodyRisk/男-鼻咽癌0.png"),
          // highlightSrc: require("@/assets/images/bodyRisk/男-鼻咽癌h.png"),
          point: {
            x: 464,
            y: 73,
            w: 219,
            h: 27,
          },
          tPoint: {
            x: 597,
            y: 74,
            w: 82,
            h: 26,
          },
        },
        {
          title: "食管癌",
          src: require("@/assets/images/bodyRisk/男-食管癌0.png"),
          // highlightSrc: require("@/assets/images/bodyRisk/男-食管癌h.png"),
          point: {
            x: 257,
            y: 115,
            w: 214,
            h: 45,
          },
          tPoint: {
            x: 262,
            y: 116,
            w: 82,
            h: 26,
          },
        },
        {
          title: "肺癌",
          src: require("@/assets/images/bodyRisk/男-肺癌0.png"),
          // highlightSrc: require("@/assets/images/bodyRisk/男-肺癌h.png"),
          point: {
            x: 480,
            y: 157,
            w: 196,
            h: 27,
          },
          tPoint: {
            x: 604,
            y: 158,
            w: 68,
            h: 26,
          },
        },
        {
          title: "缺血性心血管病",
          src: require("@/assets/images/bodyRisk/男-缺血性心血管病0.png"),
          // highlightSrc: require("@/assets/images/bodyRisk/男-缺血性心血管病h.png"),
          point: {
            x: 229,
            y: 199,
            w: 243,
            h: 27,
          },
          tPoint: {
            x: 234,
            y: 200,
            w: 138,
            h: 26,
          },
        },
        {
          title: "肝癌",
          src: require("@/assets/images/bodyRisk/男-肝癌0.png"),
          // highlightSrc: require("@/assets/images/bodyRisk/男-肝癌h.png"),
          point: {
            x: 264,
            y: 241,
            w: 171,
            h: 27,
          },
          tPoint: {
            x: 269,
            y: 242,
            w: 68,
            h: 26,
          },
        },
        {
          title: "胃癌",
          src: require("@/assets/images/bodyRisk/男-胃癌0.png"),
          // highlightSrc: require("@/assets/images/bodyRisk/男-胃癌h.png"),
          point: {
            x: 489,
            y: 241,
            w: 187,
            h: 27,
          },
          tPoint: {
            x: 604,
            y: 242,
            w: 68,
            h: 26,
          },
        },
        {
          title: "糖尿病",
          src: require("@/assets/images/bodyRisk/男-糖尿病0.png"),
          // highlightSrc: require("@/assets/images/bodyRisk/男-糖尿病h.png"),
          point: {
            x: 487,
            y: 283,
            w: 196,
            h: 27,
          },
          tPoint: {
            x: 597,
            y: 284,
            w: 82,
            h: 26,
          },
        },
        {
          title: "膀胱癌",
          src: require("@/assets/images/bodyRisk/男-膀胱癌0.png"),
          // highlightSrc: require("@/assets/images/bodyRisk/男-膀胱癌h.png"),
          point: {
            x: 257,
            y: 325,
            w: 204,
            h: 54,
          },
          tPoint: {
            x: 262,
            y: 326,
            w: 82,
            h: 26,
          },
        },
        {
          title: "结直肠癌",
          src: require("@/assets/images/bodyRisk/男-结直肠癌0.png"),
          // highlightSrc: require("@/assets/images/bodyRisk/男-结直肠癌h.png"),
          point: {
            x: 468,
            y: 325,
            w: 221,
            h: 41,
          },
          tPoint: {
            x: 590,
            y: 326,
            w: 96,
            h: 26,
          },
        },
      ],
      editableTabsValue: "0",
      editableTabs: [],
      diseaseRiskWidth: 0,
      diseaseInfo: {},
      bodyPartData: {},
      riskResultData: [],
      healthRiskData: null,
    };
  },
  created() {},
  mounted() {
    this.gender = localStorage.getItem("user-sex");
    this.getHealthRiskEstimateList();
  },
  methods: {
    getRiskLevelClassName(level) {
      if (level == "风险暂无") {
        return "persionBodyPart filter-img1";
      } else if (level == "风险较低") {
        return "persionBodyPart filter-img2";
      } else if (level == "风险一般") {
        return "persionBodyPart filter-img3";
      } else if (level == "风险较高") {
        return "persionBodyPart filter-img4";
      } else if (level == "风险极高") {
        return "persionBodyPart filter-img5";
      } else {
        return "persionBodyPart filter-img6";
      }
    },
    getText(level) {
      if (level == 50) {
        return "风险极低";
      } else if (level == 100) {
        return "风险较低";
      } else if (level == 150) {
        return "风险一般";
      } else if (level == 200) {
        return "风险较高";
      } else if (level == 250) {
        return "风险极高";
      } else {
        return "未知";
      }
    },
    async getHealthRiskEstimateList() {
      let data = null;
      if (!this.$store.state.healthDocUser.isChannelArchive) {
        let phone = this.$store.state.healthDocUser.phone;
        data = await getHealthUserAllDiseaseRisk({
          phoneNumber: phone,
        });
      } else {
        data = await getHealthRiskEstimateList({
          userId: this.$store.state.healthDocUser.userId,
        });
      }
      if (data.code == 200) {
        data.data.forEach((a) => {
          a.rValueLevelList = a.rvalueLevelList;
        });
        let respondData = data.data;
        let healthRiskData = respondData;

        if (!healthRiskData || !healthRiskData.length) {
          return;
        }

        this.healthRiskData = healthRiskData;

        this.editableTabs = [];
        healthRiskData.forEach((item, index) => {
          if (item.riskLevelName != "已患") {
            let obj = {
              title: item.diseaseName,
              name: `${index}`,
            };
            this.editableTabs.push(obj);
          }
        });

        if (this.gender == 0) {
          this.riskResultData2.forEach((item, index) => {
            let findItem = healthRiskData.find((element) => {
              return element.diseaseName == item.title;
            });
            if (findItem) {
              item.riskLevelName = findItem.riskLevelName;
              item.diseaseId = findItem.diseaseId;
              // if (
              //   findItem.riskLevelName == "已患" ||
              //   findItem.riskLevelName == "风险较高" ||
              //   findItem.riskLevelName == "风险极高"
              // ) {
              // item.src = require("@/assets/images/bodyRisk/男-" +
              // findItem.diseaseName +
              // "1.png");
              // } else if (
              //   findItem.riskLevelName == "风险一般" ||
              //   findItem.riskLevelName == "风险较低" ||
              //   findItem.riskLevelName == "风险极低"
              // ) {
              item.src = require("@/assets/images/bodyRisk/男-" +
                findItem.diseaseName +
                ".png");
            } else {
              item.riskLevelName = "风险未知";
            }
          });
          this.riskResultData = this.riskResultData2;
        } else {
          this.riskResultData1.forEach((item, index) => {
            let findItem = healthRiskData.find((element) => {
              return element.diseaseName == item.title;
            });
            if (findItem) {
              item.riskLevelName = findItem.riskLevelName;
              item.diseaseId = findItem.diseaseId;
              if (
                findItem.riskLevelName == "已患" ||
                findItem.riskLevelName == "风险较高" ||
                findItem.riskLevelName == "风险极高"
              ) {
                item.src = require("@/assets/images/bodyRisk/女-" +
                  findItem.diseaseName +
                  "1.png");
              } else if (
                findItem.riskLevelName == "风险一般" ||
                findItem.riskLevelName == "风险较低" ||
                findItem.riskLevelName == "风险极低"
              ) {
                item.src = require("@/assets/images/bodyRisk/女-" +
                  findItem.diseaseName +
                  ".png");
              }
            } else {
              item.riskLevelName = "风险未知";
            }
          });
          this.riskResultData = this.riskResultData1;
        }

        this.$nextTick(() => {
          let container = this.$refs.riskFactor.getBoundingClientRect();
          let riskFactorWidth = container.width;
          let riskFactorHeight = container.height;
          this.riskResultData.forEach((item, index) => {
            item.point.x = (item.point.x * riskFactorWidth) / 930;
            item.point.y = (item.point.y * riskFactorWidth) / 930;
            item.point.w = (item.point.w * riskFactorWidth) / 930;
            item.point.h = (item.point.h * riskFactorWidth) / 930;

            item.tPoint.x = (item.tPoint.x * riskFactorWidth) / 930;
            item.tPoint.y = (item.tPoint.y * riskFactorWidth) / 930;
            item.tPoint.w = (item.tPoint.w * riskFactorWidth) / 930;
            item.tPoint.h = (item.tPoint.h * riskFactorWidth) / 930;
          });
        });

        this.$nextTick(() => {
          this.drawChart(respondData);
        });

        if (this.editableTabs.length) {
          this.editableTabsValue = this.editableTabs[0].name;
          let index = parseInt(this.editableTabsValue);
          let diseaseId = healthRiskData[index].diseaseId;
          this.getRValueDiseaseInfo(diseaseId);
        }

        this.$nextTick(() => {
          this.resetDiseaseRiskWidth();
        });
      }
    },
    async getData(flag, index) {
      let currentItem = this.riskResultData[index];

      let data = null;
      if (!this.$store.state.healthDocUser.isChannelArchive) {
        let phone = this.$store.state.healthDocUser.phone;
        data = await getHealthRValueDiseaseInfo({
          phoneNumber: phone,
          diseaseId: currentItem.diseaseId,
        });
      } else {
        data = await getRValueDiseaseInfo({
          userId: this.$store.state.healthDocUser.userId,
          diseaseId: currentItem.diseaseId,
        });
      }
      if (data.code == 200) {
        let respondData = data.data;
        this.bodyPartData = respondData;
      }
      this.riskResultData.forEach((item, idx) => {
        if (idx == index) {
        } else {
        }
      });
    },
    resetDiseaseRiskWidth() {
      // window.setTimeout(() => {
      //   let containerProgress = document.getElementById("container-progress");
      //   let container = containerProgress.getBoundingClientRect();
      //   let width = container.width;
      //   this.diseaseRiskWidth = ((width - 120) / 5) * 3;
      // }, 300);
    },
    handleClick(tab, event) {
      let index = parseInt(tab.name);
      let diseaseId = this.healthRiskData[index].diseaseId;
      this.getRValueDiseaseInfo(diseaseId);
    },
    async getRValueDiseaseInfo(diseaseId) {
      let data = null;
      if (!this.$store.state.healthDocUser.isChannelArchive) {
        let phone = this.$store.state.healthDocUser.phone;
        data = await getHealthRValueDiseaseInfo({
          phoneNumber: phone,
          diseaseId: diseaseId,
        });
      } else {
        data = await getRValueDiseaseInfo({
          userId: this.$store.state.healthDocUser.userId,
          diseaseId: diseaseId,
        });
      }
      if (data.code == 200) {
        let respondData = data.data;
        if (!isEmpty(respondData.riskFactorList)) {
          let controlRiskList = [];
          let unControlRiskList = [];

          let riskDegree = [];
          let item1 = {
            title: "影响极大",
            list: [],
          };
          let item2 = {
            title: "影响较大",
            list: [],
          };
          let item3 = {
            title: "影响一般",
            list: [],
          };
          let item4 = {
            title: "影响较小",
            list: [],
          };

          respondData.riskFactorList.forEach((item) => {
            if (item.hasControl) {
              controlRiskList.push(item);
            } else {
              unControlRiskList.push(item);
            }
            if (item.diseaseInfluenceLevel == "影响极大") {
              item1.list.push(item);
            } else if (item.diseaseInfluenceLevel == "影响较大") {
              item2.list.push(item);
            } else if (item.diseaseInfluenceLevel == "影响一般") {
              item3.list.push(item);
            } else if (item.diseaseInfluenceLevel == "影响较小") {
              item4.list.push(item);
            }
          });
          respondData.controlRiskList = controlRiskList;
          respondData.unControlRiskList = unControlRiskList;

          if (item1.list.length) {
            riskDegree.push(item1);
          }
          if (item2.list.length) {
            riskDegree.push(item2);
          }
          if (item3.list.length) {
            riskDegree.push(item3);
          }
          if (item4.list.length) {
            riskDegree.push(item4);
          }

          respondData.riskDegree = riskDegree;
        }
        this.diseaseInfo = respondData;
        // console.log(111, this.diseaseInfo.theoreticalRValue);
        this.diseaseInfo.aaaa =
          this.diseaseInfo.theoreticalRiskLevel ||
          this.diseaseInfo.theoreticalRValue;
        this.diseaseInfo.referenceDocuments =
          this.diseaseInfo.referenceDocuments.replace(/\n/g, "<br>");

        if (this.diseaseInfo.rValue) {
          this.drawChart1(respondData.distributionList);
        }
      }
    },
    judgeRiskLevel(statu) {
      if (statu == "影响极大") {
        return "#E02020";
      } else if (statu == "影响较大") {
        return "#E02020";
      } else if (statu == "影响一般") {
        return "#FA6400";
      } else if (statu == "影响较小") {
        return "#FF8C00";
      }
    },
    judgeRiskLevelBg(statu) {
      if (statu == "影响极大") {
        return "rgba(224,32,32,0.1)";
      } else if (statu == "影响较大") {
        return "rgba(224,32,32,0.1)";
      } else if (statu == "影响一般") {
        return "rgba(250,100,0,0.1)";
      } else if (statu == "影响较小") {
        return "rgba(255,140,0,0.1)";
      }
    },
    getValue(level) {
      if (level == "风险极低") {
        return 50;
      } else if (level == "风险较低") {
        return 100;
      } else if (level == "风险一般") {
        return 150;
      } else if (level == "风险较高") {
        return 200;
      } else if (level == "风险极高") {
        return 250;
      } else {
        return 0;
      }
    },
    getLevel(theoreticalRValue, rValueLevelList) {
      let level = "风险极低";
      if (!rValueLevelList || !rValueLevelList.length) {
        return level;
      }
      for (let index = 0; index < rValueLevelList.length; index++) {
        const item = rValueLevelList[index];
        if (
          theoreticalRValue >= item.startScore &&
          theoreticalRValue < item.endScore
        ) {
          level = item.level;
          break;
        }
      }
      console.log("理想直：", level);
      return level;
    },
    drawChart(data) {
      let diseaseGrades = ["", "极低", "较低", "一般", "较高", "极高", ""];
      var colors = ["#7CE7AC", "#5E81F4"];

      let echartData = [];
      let echartData1 = [];
      let xAxisData = [];
      let fabingbeishuList = [];
      let fabinglvList = [];
      data.forEach((item, index) => {
        fabinglvList.push((item.fallIllRate * 100).toFixed(0));
        fabingbeishuList.push(item.relativeRiskRate);
        if (item.riskLevelName != "已患" && item.riskLevelName != "风险未知") {
          let obj = {
            name: item.diseaseName,
            value: this.getValue(item.riskLevelName),
          };
          echartData.push(obj);
          xAxisData.push(item.diseaseName);

          let maxItem = item.rValueLevelList.find((item1, index) => {
            return (
              item.averagePersonRValue >= item1.startScore &&
              item.averagePersonRValue < item1.endScore
            );
          });
          let obj1 = {
            name: item.diseaseName,
            value: this.getValue(maxItem ? maxItem.level : null),
          };
          echartData1.push(obj1);
        }
      });

      // 基于准备好的dom，初始化echarts实例,绘制图表
      let riskStatisticalChart = this.$refs.riskStatisticalChart;
      var myChart = this.$echarts.init(riskStatisticalChart);
      let _this = this;
      let option = {
        color: colors,
        legend: {
          right: "20",
          top: "20",
          data: ["用户当前风险", "一般成年人风险", "发病概率", "发病倍数"],
        },
        tooltip: {
          trigger: "axis",
          // formatter: "{a0}: {a1}<br />{b0}: {b1}<br />{c0}: {c1}",
          formatter: function (params) {
            return (
              // '<span style="color:red;">●</span>' +
              params[0].seriesName +
              ":" +
              _this.getText(params[0].value) +
              "<br/>" +
              params[1].seriesName +
              ":" +
              _this.getText(params[1].value) +
              "<br/>" +
              params[2].seriesName +
              ":" +
              params[2].value +
              "<br/>" +
              params[3].seriesName +
              ":" +
              params[3].value
            );
          },
        },
        grid: {
          // top: '2%',
          left: "2%",
          right: "2%",
          bottom: "10%",
          containLabel: true,
        },
        xAxis: [
          {
            axisLine: {
              lineStyle: {
                color: "#F7F7F7",
              },
            },
            axisTick: {
              show: false,
            },
            // //网格样式
            // splitLine: {
            //     show: true,
            //     lineStyle:{
            //         color: ['#F7F7F7'],
            //         width: 1,
            //         type: 'solid'
            //     }
            // },
            axisLabel: {
              color: "#3B4859",
              fontSize: 12,
              rotate: 45,
            },
            type: "category",
            data: xAxisData,
            axisPointer: {
              type: "shadow",
            },
          },
        ],
        yAxis: [
          {
            nameTextStyle: {
              color: "#666",
              fontSize: 13,
            },
            axisLine: {
              lineStyle: {
                color: "#F7F7F7",
              },
            },
            axisTick: {
              show: false,
            },
            //网格样式
            splitLine: {
              show: true,
              lineStyle: {
                color: ["#F7F7F7"],
                width: 1,
                type: "solid",
              },
            },
            type: "value",
            name: "风险",
            min: 0,
            max: 250,
            interval: 50,
            axisLabel: {
              color: "#666",
              fontSize: 16,
              // 使用函数模板，函数参数分别为刻度数值（类目），刻度的索引
              formatter: function (value, index) {
                return diseaseGrades[index];
              },
            },
          },
        ],
        series: [
          {
            name: "用户当前风险",
            type: "bar",
            barWidth: 8,
            data: echartData,
          },
          {
            name: "一般成年人风险",
            type: "bar",
            barWidth: 8,
            data: echartData1,
          },
          {
            name: "发病概率",
            type: "line",
            lineStyle: {
              width: 1,
            },
            data: fabinglvList,
          },
          {
            name: "发病倍数",
            type: "line",
            lineStyle: {
              width: 1,
            },
            data: fabingbeishuList,
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    drawChart1(distributionList) {
      console.log(1);
      let bgColor = "#fff";
      // let title = '总量';
      // let count = 234444;
      let colors = [
        "#5E81F4",
        "#FF808B",
        "#8A9DF1",
        "#F4BE5E",
        "#F1A28A",
        "#8BF1B9",
      ];
      let echartData = [];
      let echartData1 = [];
      let riskLevelName = this.diseaseInfo.riskLevelName;
      distributionList.forEach((item, index) => {
        let obj = {
          name: item.level,
          value: item.rate,
          percent: item.rate,
        };
        echartData.push(obj);

        let obj1 = {
          name: item.level == riskLevelName ? "当前风险" : "",
          value: item.rate,
          percent: item.rate,
          labelLine: {
            show: item.level == riskLevelName,
          },
          label: {
            position: "outside",
            rich: {
              percent: {
                fontSize: 14,
              },
            },
          },
          itemStyle: {
            color: colors[index],
          },
        };
        echartData1.push(obj1);
      });

      console.log(2);
      let legendData = [];
      for (var j = 0; j < echartData.length; j++) {
        var data = {
          name: echartData[j].name,
          icon: "circle",
          textStyle: {
            fontSize: 18,
            color: colors[j],
          },
        };
        legendData.push(data);
      }
      let objData = this.array2obj(echartData, "name");
      // 基于准备好的dom，初始化echarts实例,绘制图表
      console.log(3);
      let riskStatisticalChart1 = this.$refs.riskStatisticalChart1;
      var myChart = this.$echarts.init(riskStatisticalChart1);
      console.log(4);
      let option = {
        backgroundColor: bgColor,
        color: colors,
        legend: {
          orient: "vertical",
          top: "center",
          left: "60%",
          itemGap: 15,
          data: legendData,
          selectedMode: false,
          formatter: function (name) {
            return `{title|${name}}{value|${parseFloat(
              objData[name].value * 100
            ).toFixed(0)}%}`;
            // return `{title|${name}}{value|${objData[name].value}}{unit|个}`
          },
          textStyle: {
            rich: {
              title: {
                color: "#333333",
                fontSize: 16,
                width: 120,
                // fontWeight: 600,
                // fontFamily: 'HuaKang',
                padding: [0, 5, 0, 0],
              },
              value: {
                color: "#333333",
                fontSize: 16,
                width: 20,
                align: "right",
                // fontWeight: 600,
                // fontFamily: 'HuaKang',
                padding: [0, 5, 0, 0],
              },
              // unit: {
              //     color: '#333333',
              //     fontSize: 16,
              //     // fontWeight: 600,
              //     // fontFamily: 'HuaKang',
              //     padding: [0, 0, 0, 0]
              // },
            },
          },
        },
        series: [
          {
            type: "pie",
            radius: ["0%", "60%"],
            center: ["25%", "50%"],
            data: echartData,
            hoverAnimation: false,
            itemStyle: {
              normal: {
                borderColor: bgColor,
                borderWidth: 0,
              },
            },
            labelLine: {
              show: false,
            },
            label: {
              show: false,
              // position: "inside",
              // formatter: function (params) {
              //   return `{percent|${params.percent}}{unit|%}`;
              // },
              // // {unit|件}{percent|${objData[name].percent}}{unit|%}
              // // formatter: params => {
              // //     return (
              // //         '{percent|' + objData[params.name].percent + '}{unit|%}'
              // //     );
              // // },
              // rich: {
              //   percent: {
              //     fontSize: 14,
              //     color: "#fff",
              //   },
              //   unit: {
              //     fontSize: 14,
              //     color: "#fff",
              //   },
              // },
            },
          },
          {
            type: "pie",
            radius: ["0%", "60%"],
            center: ["25%", "50%"],
            data: echartData1,
            hoverAnimation: false,
            // itemStyle: {
            //   normal: {
            //     borderColor: bgColor,
            //     borderWidth: 0,
            //   },
            // },
            // labelLine: {
            //   show: true,
            // },
            // label: {
            //   // position: "inside",
            //   // formatter: function (params) {
            //   //   if (params.name == riskLevelName) {
            //   //     return `{percent|当前风险}`;
            //   //   } else {
            //   //     return '';
            //   //   }
            //   // },
            //   // {unit|件}{percent|${objData[name].percent}}{unit|%}
            //   // formatter: params => {
            //   //     return (
            //   //         '{percent|' + objData[params.name].percent + '}{unit|%}'
            //   //     );
            //   // },
            //   rich: {
            //     percent: {
            //       fontSize: 14,
            //       // color: "#333",
            //     },
            //   },
            // },
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    array2obj(array, key) {
      var resObj = {};
      for (var i = 0; i < array.length; i++) {
        resObj[array[i][key]] = array[i];
      }
      return resObj;
    },
    judgeLevel(statu) {
      if (statu == 1) {
        return "rgba(255,82,108,1)";
      } else if (statu == 2) {
        return "rgba(245,166,35,1)";
      } else if (statu == 3) {
        return "rgba(14,208,2,1)";
      } else {
        return "rgba(144,82,255,1)";
      }
    },
  },
};
</script>

<style scoped>
.main {
  min-width: 1080px;
  /* padding: 100px 0; */
  overflow: scroll;
  position: relative;
  height: 100%;
  overflow-x: hidden;
}

h1 {
  padding-top: 20px;
  color: #333333;
  font-size: 16px;
}

.diseaseRiskResult {
  margin-top: 20px;
  position: relative;
}

.persionBody {
  width: 100%;
}

.persionBodyPart {
  position: absolute;
  left: 0;
  top: 0;
  width: 0px;
  height: 0px;
}

.persionBodyPart-click {
  position: absolute;
  width: 20%;
  /* height: 100%; */
  border: solid 1px royalblue;
  /* margin: 100px 40px; */
}

.persionBodyPart-left {
  left: 40px;
  top: 10%;
  bottom: 10%;
}

.persionBodyPart-right {
  right: 40px;
  top: 10%;
  bottom: 10%;
}

.persionBodyPart img {
  width: 100%;
}

.persionBodyPart-text {
  position: absolute;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
}

.persionBodyPart-risk {
  display: inline-block;
  /* text-align: center; */
  font-size: 16px;
  width: 100%;
  color: #fff;
  /* padding-bottom: 10px; */
}

.persionBodyPart-risk-item {
  border-top: #fff solid 1px;
  margin-top: 10px;
}

.persionBodyPart-risk-item-name {
  display: inline-block;
  /* text-align: center; */
  font-size: 14px;
  width: 100%;
  color: #fff;
  padding-top: 10px;
}

/* .persionBodyPart-risk-item:first-child {
	  border-top: #fff solid 1px;
	} */

.persionBodyPart-text-1 {
  display: inline-block;
  width: 100%;
}

.riskStatistical {
  overflow: hidden;
  margin-top: 10px;
  background-color: #fff;
}
.riskStatisticalChart {
  width: 100%;
  height: 400px;
}

.diseaseName {
  margin: 20px 0 0 18px;
  font-family: PingFangSC-Semibold;
  font-size: 18px;
  color: #333333;
  letter-spacing: 0.22px;
  line-height: 18px;
}

.diseaseName span {
  display: inline-block;
  margin-left: 10px;
  font-family: PingFangSC-Medium;
  font-size: 15.88px;
  color: #fc8c41;
  letter-spacing: 0;
  line-height: 15.88px;
  padding: 5px;
  background-color: rgba(250, 146, 101, 0.1);
}

.diseaseRiskCard {
  margin-top: 20px;
}

.diseaseRiskDetail {
  margin-top: -15px;
  margin-bottom: 20px;
  background-color: #fff;
  overflow: hidden;
}
.diseaseDetail {
  background: #fafafc;
  padding: 18px 20px;
  margin: 20px;
  font-family: PingFangSC-Medium;
  font-size: 14px;
  color: #333333;
  white-space: pre-wrap;
  text-align: justify;
}

.diseaseCheckRemind {
  margin: 20px;
}

.diseaseCheckRemind-title {
  font-family: PingFangSC-Medium;
  font-size: 18px;
  color: #333333;
}

.diseaseCheckRemind-content {
  background: #fafafc;
  padding: 18px 20px;
  margin-top: 24px;
  font-family: PingFangSC-Medium;
  font-size: 14px;
  color: #333333;
  white-space: pre-wrap;
  text-align: justify;
}

.diseaseRisk-compare {
  margin: 20px 0px;
  width: 100%;
  position: relative;
}

.diseaseRisk-compare p {
  position: absolute;
  left: 0;
  top: 35px;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #000000;
  letter-spacing: 0;
  text-align: center;
  line-height: 12px;
}
.diseaseRisk-compare p span {
  font-family: PingFangSC-Semibold;
  font-size: 12px;
  color: #fc8c41;
  letter-spacing: 0;
  line-height: 12px;
}

.diseaseRiskProgress {
  width: 100%;
  height: 200px;
  background-color: #fff;
}

.col {
  margin-top: 20px;
}

.col-item {
  overflow: hidden;
  background-color: #fff;
  /* height: 350px; */
}

.col-item-title {
  margin-top: 20px;
  margin-left: 18px;
  font-family: PingFangSC-Semibold;
  font-size: 18px;
  color: #333333;
  letter-spacing: 0.22px;
  line-height: 18px;
}

.col-item-title1 {
  text-align: center;
}

.riskStatisticalChart1 {
  width: 100%;
  height: 260px;
}

.historyhealthTrendChart {
  margin-top: 20px;
  width: 100%;
  height: 200px;
  /* background-color: lightgray; */
}

.riskControl-name {
  margin-top: 20px;
  margin-left: 18px;
  font-family: PingFangSC-Semibold;
  font-size: 18px;
  color: #333333;
  letter-spacing: 0.22px;
  line-height: 18px;
}

.riskControl {
  /* margin-top: 20px; */
}

.riskControlType {
  /* border: lightgray 1px solid; */
}
.card-title {
  margin-top: 16px;
  height: 16px;
  position: relative;
}
.card-title-icon {
  background-color: #0062ff;
  display: inline-block;
  width: 4px;
  height: 14px;
  position: absolute;
  transform: translate(0, -50%);
  top: 50%;
  left: 18px;
}
.card-title-name {
  margin-left: 0px;
  font-size: 16px;
  line-height: 16px;
  color: #3b4859;
  font-family: PingFangSC-Medium;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  left: 30px;
}

.diseaseRisk-control {
  margin-top: 10px;
  margin-left: 18px;
}
.diseaseRisk-item {
  display: inline-block;
  padding: 5px;
  /* padding-left: 0px; */
  margin: 5px;
  margin-left: 0px;
  background: rgba(0, 122, 255, 0.15);
  border-radius: 2px;
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #037cff;
  letter-spacing: 0;
  line-height: 16px;
}

.diseaseRisk-item1 {
  display: inline-block;
  padding: 5px;
  margin: 5px;
  margin-left: 0px;
  background: #f3f3f3;
  border-radius: 2px;
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0;
  line-height: 16px;
}

.dialogDiseaseRisk {
  margin: 16px 18px;
  /* padding: 10px; */
  /* border-top: lightgray 1px solid;
	  border-bottom: lightgray 1px solid; */
}

.dialogDiseaseRisk-prompt {
  margin-top: 20px;
  /* margin-left: 18px; */
  font-family: PingFangSC-Semibold;
  font-size: 18px;
  color: #333333;
  letter-spacing: 0.22px;
  line-height: 18px;
}

.dialogDiseaseRisk-effect {
  display: flex;
  margin: 20px 0px;
}

.dialogDiseaseRisk-effect-left {
  flex: 0 1 130px;
  position: relative;
}

.bigEffect {
  display: inline-block;
  border-radius: 2px;
  background-color: rgba(224, 32, 32, 0.1);
  padding: 5px;
  margin: 5px;
  margin-left: 0px;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  line-height: 16px;
  /* height: 16px; */
  text-align: center;
  color: #e02020;
  letter-spacing: 0;
  position: absolute;
  top: 10%;
  left: 0;
}

.bigIcon {
  /* display: inline-block; */
  /* box-sizing: content-box; */
  width: 16px;
  height: 16px;
  background-color: rgba(224, 32, 32, 0.3);
  border-radius: 8px;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(-50%, -50%);
}

.bigIcon-center {
  width: 10px;
  height: 10px;
  background-color: #e02020;
  border-radius: 5px;
  margin: 3px;
}

.dialogDiseaseRisk-effect-right {
  flex: 0 1 100%;
}

.dialogDiseaseRisk-effect-right-item {
  display: inline-block;
  background: rgba(221, 221, 221, 0.2);
  border: 1px solid #dddddd;
  border-radius: 2px;
  padding: 5px;
  margin: 5px;
}

.dialogDiseaseRisk-effect-right-item .diseaseRiskName {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #047cff;
  letter-spacing: 0.17px;
  line-height: 14px;
}

.dialogDiseaseRisk-effect-right-item .diseaseRiskValue {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #999999;
  letter-spacing: 0.17px;
  line-height: 14px;
}

.healthNonData {
  position: relative;
  height: 600px;
}

.healthNonDataImage {
  width: 400px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.healthNonDataText {
  width: 100%;
  height: 20px;
  line-height: 20px;
  font-size: 16px;
  color: #999999;
  text-align: center;
  position: absolute;
  left: 0px;
  bottom: 100px;
}
.literature-box {
}
.literature-name {
  color: #999;
  font-size: 14px;
  line-height: 18px;
  margin-bottom: 2px;
  /* margin-top: px; */
}
.literature-content {
  font-size: 12px;
  color: #999;
  margin-bottom: 16px;
  line-height: 18px;
}
.filter-img1 {
  filter: grayscale(100%);
}
.filter-img2 {
  filter: hue-rotate(270deg);
}
.filter-img3 {
  filter: hue-rotate(230deg);
}
.filter-img4 {
  filter: hue-rotate(190deg);
}
.filter-img5 {
  filter: hue-rotate(180deg);
}
.filter-img6 {
  filter: hue-rotate(155deg);
}
</style>

<style>
/* .poper-persionBodyPart {
	  background-color: transparent !important;
	  border-color: royalblue !important;
	  min-width: 100px;
	}

	.poper-persionBodyPart .popper__arrow {
	  border-right-color: royalblue !important;
	}
	.poper-persionBodyPart .popper__arrow::after {
	  border-right-color: transparent !important;
	}

	.poper-persionBodyPart .popper__arrow {
	  border-left-color: royalblue !important;
	}
	.poper-persionBodyPart .popper__arrow::after {
	  border-left-color: transparent !important;
	} */
</style>
